<!--@if (!isTabScreen()) {-->
<div class="row mb-2">
  <div [ngClass]="{
  'col-9 col-sm-9 col-md-9 col-lg-9 col-xl-9': view == 'Normal',
  'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12': view == 'POS'
}">
    <div class="row">
      <!-- Menus are a handful at most, so show them inline: switching is one click
           instead of open-dropdown-then-pick. Scrolls sideways if a tenant has many. -->
      <div class="col-12 mb-2">
        <div class="menu-tabs">
          @for (menu of menusWithFoods; track menu.menuId) {
            <button type="button" class="menu-tab"
              [class.menu-tab-active]="menu.menuId === selectedMenuId"
              (click)="onMenuChange(menu.menuId)">
              {{ menu.menuName }}
            </button>
          }
        </div>
      </div>
      <!-- <div class="col-3">
         <div
           class="cursor filter-item d-flex justify-content-between"
           nz-dropdown
           nzTrigger="click"
           [nzDropdownMenu]="menu2"
         >
           <span class="dropdown-muted">Food Item Type</span>
           <em class="dropdown-muted ms-2" nz-icon nzType="down"></em>
         </div>

         <nz-dropdown-menu #menu2="nzDropdownMenu">
           <ul nz-menu>
             <nz-checkbox-group
               [(ngModel)]="typeKeyValue"
               (ngModelChange)="onType(typeKeyValue)"
               class="d-flex px-2 flex-column"
             ></nz-checkbox-group>
           </ul>
         </nz-dropdown-menu>
       </div>
       <div class="col-3">
         <div
           class="cursor filter-item d-flex justify-content-between"
           nz-dropdown
           nzTrigger="click"
           [nzDropdownMenu]="menu3"
         >
           <span class="dropdown-muted">Search Tag</span>
           <em class="dropdown-muted ms-2" nz-icon nzType="down"></em>
         </div>

         <nz-dropdown-menu #menu3="nzDropdownMenu">
           <ul nz-menu>
             <nz-checkbox-group
               (ngModelChange)="onSearchTag(searchTagKeyValue)"
               [(ngModel)]="searchTagKeyValue"
               class="d-flex px-2 flex-column"
             ></nz-checkbox-group>
           </ul>
         </nz-dropdown-menu>
       </div>-->
      <div class="col-12">
        <div class="d-flex">
          <input
            #searchInput
            nz-input
            placeholder="Search (Double Space)"
            class="w-100 me-3"
            [(ngModel)]="searchValue"
            (input)="liveSearch()"
          />
          <button nz-button nzType="primary" (click)="onAddFood()" class="btn-with-shortcut"><span class="btn-text"><em class="las la-plus me-1"></em><span class="add-food-label">Add Food</span></span></button>
        </div>
      </div>
    </div>
  </div>
  <!--    @if (view == 'Normal') {-->
  <!--      <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 my-auto">-->
  <!--        <div class="d-flex ms-1">-->
  <!--          <div>-->
  <!--            Sec. : {{ orderDetails.sectionName }}-->
  <!--          </div>-->
  <!--          <div class="d-flex ms-3">-->
  <!--            <div class="d-flex" *ngFor="let table of orderDetails.tables; let i = index">-->
  <!--              T. : {{ table | tableName: tables }} <span *ngIf="i !== orderDetails.tables.length - 1">,</span>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    }-->
</div>
<!--} @else {-->
<!--  <div class="d-flex justify-content-between">-->
<!--    <div class="d-flex my-auto ms-2">-->
<!--      <div>-->
<!--        Sec. : {{ orderDetails.sectionName }}-->
<!--      </div>-->
<!--      <div class="d-flex ms-3">-->
<!--        <div class="d-flex" *ngFor="let table of orderDetails.tables; let i = index">-->
<!--          T. : {{ table | tableName: tables }} <span *ngIf="i !== orderDetails.tables.length - 1">,</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div (click)="onCart()">-->
<!--      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#000000" viewBox="0 0 256 256">-->
<!--        <path-->
<!--          d="M233.21,56.31A12,12,0,0,0,224,52H66L60.53,21.85A12,12,0,0,0,48.73,12H24a12,12,0,0,0,0,24H38.71L63.62,173a28,28,0,0,0,4.07,10.21A32,32,0,1,0,123,196h34a32,32,0,1,0,31-24H91.17a4,4,0,0,1-3.93-3.28L84.92,156H196.1a28,28,0,0,0,27.55-23l12.16-66.86A12,12,0,0,0,233.21,56.31ZM100,204a8,8,0,1,1-8-8A8,8,0,0,1,100,204Zm88,8a8,8,0,1,1,8-8A8,8,0,0,1,188,212Zm12-83.28A4,4,0,0,1,196.1,132H80.56L70.38,76H209.62Z"></path>-->
<!--      </svg>-->
<!--    </div>-->
<!--  </div>-->
<!--}-->

<div class="row g-0 menu-layout">
  <div class="category-sidebar col-sm-3 col-md-3 col-lg-3 col-xl-2 scrollItems pe-2">
    @for (category of categoryFoods; track category.categoryName; let i = $index) {
      <div class="category-box text-center cursor"
           [class.category-box-active]="category.categoryName === selectedCategory"
           [class.category-selected]="i === selectedCategoryIndex && category.categoryName !== selectedCategory"
           (click)="onSelectCategory(category.categoryName)">
        <p class="mb-0">{{ category.categoryName }}</p>
      </div>
    }
  </div>
  <div class="food-grid-col col-sm-9 col-md-9 col-lg-9 col-xl-10 scrollItems ps-2">
    <div class="food-card-grid">
      @for (food of foodItems; track food.foodId; let i = $index) {
        <div class="food-card-wrapper">
          <!--          <div class="food-box text-center cursor" (click)="onAddToCart(food)">-->
          <!--            <div class="d-flex flex-column">-->
          <!--              <p class="mb-0">{{ food.foodName }}</p>-->
          <!--              <p class="mb-0 fw-bold">{{ food.price | number }}</p>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="food-card cursor" [class.food-selected]="i === selectedFoodIndex" (click)="onAddToCart(food)">
            @if (food.imageUrls && food.imageUrls.length > 0) {
              <div class="food-image-container">
                <img [src]="food.imageUrls[0]" alt="Food Image" class="food-image"/>
              </div>
            }
            <div class="p-2">

              <!-- Food Name -->
              <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="flex-grow-1">
                  <p class="mb-0 text-weight food-name">{{ food.foodName }}</p>
                </div>
              </div>

              <!-- Description -->
              <!--              <div class="food-description mb-2">-->
              <!--                <p class="text-muted mb-0">{{ food.foodDescription ?? '' | truncate: 50 }}</p>-->
              <!--              </div>-->

              <div class="d-flex justify-content-between gap-2">
                <!-- Item Code Badge -->
                <div class="item-code-badge">
                  <span class="badge badge-outline">{{ food.foodItemCode }}</span>
                </div>

                <!--                 Veg/Non-veg Indicator-->
                <div class="veg-indicator-no-image">
                  @if (checkVeggieStatus(food.foodTypeNames)) {
                    <img ngSrc="assets/images/veg-icon.png" width="18" height="18" alt="veg">
                  } @else if (checkNonVeggieStatus(food.foodTypeNames)) {
                    <img ngSrc="assets/images/non-veg-icon.png" width="18" height="18" alt="non-veg">
                  }
                </div>
              </div>

              <div class="price-section">
                <p class="price-label mb-1">Price Options:</p>
                <div class="price-ranges">
                  @for (range of getSortedQuantityTags(food.foodFoodQuantityTags); track range.foodQuantityTagId) {
                    <div class="price-tag">
                      <span class="size-code">{{ getQtyTagName(range.foodQuantityTagId) }}</span>
                      <span class="price-amount">{{ range.additionalPrice + food.foodBasePrice | number }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
